
document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("product-review-form");
  const messageEl = document.getElementById("review-message");

  form?.addEventListener("submit", async function (e) {
    e.preventDefault();
    if (messageEl) messageEl.textContent = "";

    const formData = new FormData(form);
    const data = {};
    formData.forEach((value, key) => data[key] = value);

    try {
      const response = await fetch("https://shopifyreviewappforme.shop/submit-review.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data)
      });

      const result = await response.json();

      if (result.success) {
        messageEl.textContent = "Review submitted successfully!";
        messageEl.style.color = "green";
        form.reset();
      } else {
        messageEl.textContent = result.error || "Submission failed.";
        messageEl.style.color = "red";
      }
    } catch (err) {
      messageEl.textContent = "Network error. Please try again.";
      messageEl.style.color = "red";
    }
  });
});
